import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Link, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { MenuItem } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const SystemUsersGroupsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const { data, parameters, menu, idAirport } = useGlobalState();
    const [usersGroups, setUsersGroups] = useState<any[]>([]);
    const [menus, setMenus] = useState<MenuItem[]>([]);
    const [group, setGroup] = useState<any>();
    const [idGroup, setIdGroup] = useState<number>(0);
    const { navigate } = useRouter();

    useEffect(() => {
        handleUserGroups();
    }, [idAirport]);
    const handleUserGroups = async () => { // Make the function async
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/usergroups/list',
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setUsersGroups(dataWeb.userGroups)
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }
    useEffect(() => {
        //setGroup(null);
        handleUserGroups();
    }, []);


    // When group.jsonMenu arrives, update checkedItems

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1">{group ? `Grupo ${group.groupName}` : "Grupos de usuario"}</Header>


                    {usersGroups && usersGroups.length > 0 && (
                        <Table
                            variant="borderless"
                            stickyHeader
                            columnDefinitions={[
                                { id: 'idGroup', header: 'ID', cell: item => item.idGroup, width: 60 },
                                { id: 'groupName', header: 'Nombre Grupo', cell: item => item.groupName },
                                { id: 'modules', header: 'Módulos', cell: item => <Link href={`#system/users/group.edit?id=${item.idGroup}`}>{item.jsonMenu.length || "0"}</Link> },
                            ]}
                            items={usersGroups}

                        />
                    )}

                </SpaceBetween>
            }
        />
    )
};
